import { Text } from "@ecco/ui/text";
import { Box } from "@ecco/ui/box";
import { use } from "react";
import { Controller } from "./controller";

export const StoreCount = ({ microcopy, isExtraLargeViewport = false }) => {
    const { filterDistance, storesInList } = use(Controller);
    return filterDistance && filterDistance.value !== "COUNTRY" ? (
        //We will set a fix height to avoid layout shifts when the value changes
        <Text ml={[isExtraLargeViewport ? 3 : 0, 0]} h="4" color="gray.500">
            {storesInList} {microcopy} {filterDistance?.label}
        </Text>
    ) : (
        <Box h="4"></Box>
    );
};
